import NotificationService from '@/shared/services/NotificationService';

const MUTATING_METHODS = new Set(['post', 'put', 'patch', 'delete']);

/** Ne osvežavamo brojač posle samih notification API poziva (izbegava petlju). */
function isNotificationApiUrl(url) {
  if (!url || typeof url !== 'string') return false;
  return url.includes('/notification/');
}

let refreshTimer = null;

/**
 * Invalidira keš i obaveštava sve слушаоце (header bell, profile badge, …).
 * Debounce spaja više uzastopnih mutacija u jedan refresh.
 */
export function scheduleNotificationCountRefresh() {
  if (refreshTimer) {
    clearTimeout(refreshTimer);
  }
  refreshTimer = window.setTimeout(() => {
    refreshTimer = null;
    NotificationService.invalidateSearchCache();
    window.dispatchEvent(new CustomEvent('notificationsUpdated'));
  }, 80);
}

/**
 * Poziva se iz axios response interceptora posle uspešnih mutirajućih zahteva.
 */
export function maybeScheduleNotificationCountRefresh(response) {
  const method = (response?.config?.method || '').toLowerCase();
  if (!MUTATING_METHODS.has(method)) return;
  const url = response?.config?.url || '';
  if (isNotificationApiUrl(url)) return;
  scheduleNotificationCountRefresh();
}
